<template>
  <div class="row mb-1">
    <div id="mention-reach" class="col-md-12 px-gap">
      <div class="card card-default shade">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">Grafik Mention dan Reach</h4>
                <p class="small hint-text">Grafik Mention dan Reach</p>
              </div>
              <div class="pull-right">
                <div class="form-check form-check-inline switch m-t-20 m-b-0">
                  <input
                    type="checkbox"
                    v-model="show_grafik_mention"
                    id="barchart-mention"
                  />
                  <label for="barchart-mention">
                    Tampilkan Grafik Pie dan Bar
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <loader-component style="margin: auto" v-if="data_stats === null" />
            <div
              v-else-if="
                data_stats.engagement == '0' &&
                data_stats.esmr == '0' &&
                data_stats.total == '0'
              "
              class="col-md-2 col-sm-2"
            >
              <div
                class="alert alert-danger"
                id="errorApiEl"
                role="alert"
                align="center"
              >
                <strong>Mohon maaf, data tidak tersedia! </strong>
                <br />
                Tidak dapat menampilkan grafik dengan data kosong.
              </div>
            </div>

            <div v-else class="col-md-2 col-sm-2">
              <div v-if="!show_grafik_mention">
                <div class="analytic-card">
                  <p>MENTION</p>
                  <h4 style="color: #6f42c1 !important">
                    <i class="bi bi-chat-dots-fill"></i>
                    {{
                      data_stats === null && typeof data_stats !== "undefined"
                        ? "0"
                        : data_stats.total | thousandSeparator
                    }}
                  </h4>
                </div>
                <div class="analytic-card">
                  <p>REACH</p>
                  <h4 style="color: #fd7e14 !important">
                    <i class="bi bi-megaphone"></i>
                    {{
                      data_stats === null && typeof data_stats !== "undefined"
                        ? "0"
                        : data_stats.esmr | thousandSeparator
                    }}
                  </h4>
                </div>
                <div class="analytic-card">
                  <p>ENGAGEMENT</p>
                  <h4 style="color: #17a2b8 !important">
                    <i class="bi bi-share-fill"></i>
                    {{
                      data_stats === null && typeof data_stats !== "undefined"
                        ? "0"
                        : data_stats.engagement | thousandSeparator
                    }}
                  </h4>
                </div>
              </div>
              <div v-else>
                <pie-chart-component :data="data_pie" :config="config_pie" />
              </div>
            </div>
            <div class="col-md-10 col-sm-10">
              <loader-component
                v-if="
                  data_series === null && typeof data_series !== 'undefined'
                "
              />
              <div
                v-else-if="Object.keys(data_series).length === 0"
                class="alert alert-danger"
                id="errorApiEl"
                role="alert"
                align="center"
              >
                <strong>Mohon maaf, data tidak tersedia! </strong>
                <br />
                Tidak dapat menampilkan grafik dengan data kosong.
              </div>
              <div v-else>
                <line-chart-component
                  v-if="!show_grafik_mention"
                  :key="component_key"
                  :data="data_series"
                  el="linechart-mention-reach"
                  mode="dual"
                />
                <div v-else>
                  <bar-chart-component :data="data_bar" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import line_chart_dual_axis from "@/views/components/chart/line_chart_dual_axis.vue";
import bar_chart_horizontal from "@/views/components/chart/bar_chart_horizontal.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import loader_component from "@/views/components/loader.vue";

export default {
  name: "medsos_mention_reach",
  components: {
    "line-chart-component": line_chart_dual_axis,
    "bar-chart-component": bar_chart_horizontal,
    "pie-chart-component": pie_chart,
    "loader-component": loader_component,
  },
  props: {
    data: Object,
    stats: Object,
  },
  data() {
    return {
      data_series: this.data,
      data_stats: this.stats,
      data_bar: {
        x: [],
        y: [],
      },
      show_grafik_mention: false,
      component_key: 0,
      data_pie: [],
      config_pie: {
        align: "center",
      },
    };
  },
  methods: {
    assemblePieChart() {
      if (
        this.data_stats.engagement != "0" &&
        this.data_stats.esmr != "0" &&
        this.data_stats.total != "0"
      ) {
        this.data_pie = [
          {
            color: "#6f42c1",
            name: "Mention",
            y: parseInt(this.data_stats.total),
          },
          {
            color: "#fd7e14",
            name: "Reach",
            visible: false,
            y: parseInt(this.data_stats.esmr),
          },
          {
            color: "#17a2b8",
            name: "Engagement",
            y: parseInt(this.data_stats.engagement),
          },
        ];
      }
    },
  },
  created: function () {
    if (this.data_stats) {
      this.assemblePieChart();
    }
    if (this.data_series != null && typeof this.data_series !== "undefined") {
      this.data_bar.x = this.data_series.date;
      this.data_bar.y = [
        {
          color: "#6f42c1",
          name: "Mention",
          data: this.data_series.mention,
        },
        {
          color: "#fd7e14",
          name: "Reach",
          visible: false,
          data: this.data_series.reach,
        },
        {
          color: "#17a2b8",
          name: "Engagement",
          data: this.data_series.engagement,
        },
      ];
      this.component_key++;
    }
  },
};
</script>

<style scoped>
.analytic-card {
  padding: 5px 20px;
}
</style>